import { makeUnauthGetRequest } from "../../../utils/lambda/unauthRequests"

import { STORE_PASSWORD_CRITERIA } from "../constants"

export const storePasswordAction = (passwordCriteria, adminOnly) => ({
  adminOnly,
  passwordCriteria,
  type: STORE_PASSWORD_CRITERIA,
})

// eslint-disable-next-line import/prefer-default-export
export const storePasswordCriteria = (dispatch) => {
  makeUnauthGetRequest({
    url: "/iam_v1/password-policy",
    onSuccess: ({
      password_minimum_length,
      password_require_lowercase,
      password_require_numbers,
      password_require_symbols,
      password_require_uppercase,
      self_service_password_recovery,
    }) => {
      dispatch(
        storePasswordAction(
          {
            length: password_minimum_length,
            lowerCase: password_require_lowercase,
            upperCase: password_require_uppercase,
            numbers: password_require_numbers,
            symbols: password_require_symbols,
          },
          !self_service_password_recovery
        )
      )
    },
    onFailure: console.error,
  })
}
